import { c as _c } from "react/compiler-runtime";
import { ProgressBar } from "@/components/ProgressBar";
import { Tabs } from "@/components/Tabs";
import { Code, Sparkles } from "lucide-react";
import { useState } from "react";
interface Skill {
  name: string;
  percentage: number;
}
interface SectionTabsProps {
  skills: Skill[];
  interests: string[];
}
const PROGRESS_BAR_DURATION = 1500;
const PROGRESS_BAR_DELAY_OFFSET = 150;
const tabItems = [{
  id: "skills",
  label: "Top Skills",
  icon: <Code className="w-4 h-4" />
}, {
  id: "interests",
  label: "Interests",
  icon: <Sparkles className="w-4 h-4" />
}];
const SkillsList = t0 => {
  const $ = _c(4);
  const {
    skills
  } = t0;
  let t1;
  if ($[0] !== skills) {
    t1 = skills.map(_temp);
    $[0] = skills;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col gap-4" role="list">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const InterestsList = t0 => {
  const $ = _c(4);
  const {
    interests
  } = t0;
  let t1;
  if ($[0] !== interests) {
    t1 = interests.map(_temp2);
    $[0] = interests;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="flex flex-col gap-4" role="list">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const SectionTabs = t0 => {
  const $ = _c(9);
  const {
    skills,
    interests
  } = t0;
  const [activeTab, setActiveTab] = useState("skills");
  let t1;
  if ($[0] !== activeTab) {
    t1 = <Tabs items={tabItems} activeTab={activeTab} onTabChange={setActiveTab} />;
    $[0] = activeTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeTab || $[3] !== interests || $[4] !== skills) {
    t2 = <div className="flex-1 flex flex-col min-h-0 overflow-auto" role="tabpanel" aria-live="polite">{activeTab === "skills" ? <SkillsList skills={skills} /> : <InterestsList interests={interests} />}</div>;
    $[2] = activeTab;
    $[3] = interests;
    $[4] = skills;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="border border-white/20 rounded-4xl p-6 flex-1 flex flex-col min-h-125 lg:min-h-0">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(skill, index) {
  return <div key={skill.name} className="flex flex-col gap-2" role="listitem"><div className="flex justify-between items-center"><span className="body-base font-semibold">{skill.name}</span><span className="body-small text-glow" aria-label={`${skill.percentage} percent`}>{skill.percentage}%</span></div><ProgressBar percentage={skill.percentage} duration={PROGRESS_BAR_DURATION} delay={index * PROGRESS_BAR_DELAY_OFFSET} /></div>;
}
function _temp2(interest) {
  return <li key={interest} className="body-base transition-colors duration-200">{interest}</li>;
}